<template>
  <div class="flex items-center">
    <Star fill="#FEBF5C" />
    <Star fill="#FEBF5C" />
    <Star fill="#FEBF5C" />
    <Star fill="#FEBF5C" />
    <Star fill="#DBDBDB" />
  </div>
</template>

<script>
import Star from "./icons/Star.vue";

export default {
  components: { Star },
};
</script>
